import React, { useEffect, useState } from "react";
import "./roles.scss";
import { Button, Col, Divider, Row, Typography } from "antd";
import Icon from "../../../../components/icon/icon";
import { AddRoleModal } from "../../../../components/addRoleModal/addRoleModal";
import { GetPermissionRes, GetRoleRes } from "../../../../interfaces/role.interface";
import { HandleErrors } from "../../../../utils/handleErrors";
import { getRolesService } from "../../../../services/role.service";
import { UpdateRoleModal } from "../../../../components/updateRoleModal/updateRoleModal";
import { DeleteRoleModal } from "../../../../components/deleteRoleModal/deleteRoleModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { PermissionCode } from "../../../../enum/permission";

const Role = () => {
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const health = useSelector<RootState, string>(
      (root) => root.app.health
    );

  const [addRoleModal, setAddRoleModal] = useState(false);
  const [updateRoleModal, setUpdateRoleModal] = useState(false);
  const [deleteRoleModal, setdeleteRoleModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [roles, setRoles] = useState<GetRoleRes[]>([]);
  const [selectedRole, setSelectedRole] = useState<GetRoleRes>({
    description: "",
    id: 0,
    name: "",
    permissions: []
  });

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    try {
      if(health == 'license-false'){
        return
      }
      setLoading(true);
      const res = await getRolesService({});
      setRoles(res.list);
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="OrganizationRole">
      {health == 'license-false' && <div style={{
          position: 'absolute',
          zIndex: '100000',
          width: '100%',
          height: '100%',
          top: 0,
          right: 0,
          backdropFilter: 'blur(3px)',
          backgroundColor: 'rgba(255, 255, 255, 0.5)' /* optional tint */
        }}>
      </div>}
      <Row align={"middle"} justify={"space-between"} className="title-box">
        <Col>
          <Typography.Text className="title">نقش های سازمان</Typography.Text>
        </Col>
        <Col xs={10} md={4}>
          {userPermissions.find(p => p.code === PermissionCode.createNewRole) && <div
            className="btn-box"
            onClick={() => {
              setAddRoleModal(true);
            }}
          >
            <Icon src="/assets/icons/Add - Circle.svg" />
            <Typography.Text className="title">افزودن نقش</Typography.Text>
          </div>}
        </Col>
      </Row>
      <div className="info-box">
        <Row>
          <Col>
            <Typography.Text className="title">لیست نقش ها</Typography.Text>
          </Col>
        </Row>

        <Divider />

        {roles.map((item, index) => {
          if(item.id === 1){
            return<></>
          }
          return (
            <div className="role-box">
              <Row align={"middle"} justify={"space-between"}>
                <Col className="title-box">
                  <Typography.Text className="title">
                    {item.name}
                  </Typography.Text>
                  <Typography.Text className="desc">
                    {item.description}
                  </Typography.Text>
                </Col>
                <Col className="btn-box">
                  {userPermissions.find(p => p.code === PermissionCode.updateRole) && <div className="btn" onClick={()=>{
                    setSelectedRole(item)
                    setUpdateRoleModal(true)
                  }}>
                    <Icon src="/assets/icons/Pen.svg" />
                  </div>}
                  <div className="btn" onClick={()=>{
                    setSelectedRole(item)
                    setdeleteRoleModal(true)
                  }}>
                    <Icon src="/assets/icons/Trash Can.svg" />
                  </div>
                </Col>
              </Row>
              <Divider />
              <Row>
                <Col className="permissions-title-box">
                  <Typography.Text className="title">
                    لیست دسترسی ها
                  </Typography.Text>
                </Col>
              </Row>
              <Row justify={"start"} align={"middle"}>
                {item?.permissions?.map((permission) => {
                  return (
                    <Col md={6} xs={24}>
                      <div className="permission-box">
                        <Icon src="/assets/icons/Tick - Circle.svg" />
                        <Typography.Text className="title">
                          {permission.name}
                        </Typography.Text>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          );
        })}
      </div>
      <AddRoleModal
        show={addRoleModal}
        onClose={() => {
          getRoles();
          setAddRoleModal(false);
        }}
      />
      <UpdateRoleModal
        show={updateRoleModal}
        onClose={() => {
          getRoles();
          setUpdateRoleModal(false);
        }}
        role={selectedRole}
      />
      <DeleteRoleModal
        show={deleteRoleModal}
        onClose={() => {
          getRoles();
          setdeleteRoleModal(false);
        }}
        role={selectedRole}
      />
    </div>
  );
};

export default Role;
